export default "__VITE_PUBLIC_ASSET__a181432c__"